<!-- Created by Richard on 15/03/2021-->

<template>
  <ViewTab title="My CV:" :under-construction="true">
    <p>eventually I'll put my CV here as an embedded pdf</p>
  </ViewTab>
</template>

<script>
import ViewTab from "@/views/ViewTab";

export default {
  name: "CurriculumVitae",
  components: {ViewTab},
}
</script>

<style scoped>

</style>